export enum OfficeOnlineApp {
    Word = 1,
    Excel,
    PowerPoint
}
